export var UserRole;
(function (UserRole) {
    UserRole["THERAPPROVE_ADMIN"] = "TherapproveAdmin";
    UserRole["ORGANIZATION_OWNER"] = "OrganizationOwner";
    UserRole["ORGANIZATION_ADMIN"] = "OrganizationAdmin";
    UserRole["CASE_MANAGER"] = "CaseManager";
    UserRole["PROVIDER"] = "Provider";
})(UserRole || (UserRole = {}));
export const LEGACY_ORGANIZATION_ROLE = "Organization";
export const normalizeUserRole = (role) => {
    if (!role) {
        return undefined;
    }
    const normalizedRole = role.replace(/[_\s]/g, "").toUpperCase();
    if (normalizedRole === "ORGANIZATION" ||
        normalizedRole === "ORGANIZATIONOWNER") {
        return UserRole.ORGANIZATION_OWNER;
    }
    if (normalizedRole === "ORGANIZATIONADMIN") {
        return UserRole.ORGANIZATION_ADMIN;
    }
    if (normalizedRole === "CASEMANAGER") {
        return UserRole.CASE_MANAGER;
    }
    if (normalizedRole === "PROVIDER") {
        return UserRole.PROVIDER;
    }
    if (normalizedRole === "THERAPPROVEADMIN") {
        return UserRole.THERAPPROVE_ADMIN;
    }
    return undefined;
};
